<template>
  <div>
    <div data-v-60016932="" class="Setting transitionBody">
      <div data-v-60016932="" class="head_area">
          <div data-v-60016932="" class="leftImg"><img @click="back" data-v-60016932=""
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAdCAYAAACjbey/AAACgklEQVRIS52UzWsTQRiHf++ktaVIixooiEIPHqTgQQIiCJpds7u1oqbZjT3Yk/SgB+tJPfhB0XpQFBRBRRQUQbH5KBSUbtJuoiCCUC/+AZ68SKtYRCRt5pVdaclu2k3qHmfm98y77zwzhP/6RgUwKt0orScfix3p6Iy2PScgycwfuFJJNg2Ix+Ptoi06CUBb2ZQx1hSgtze9oXubnCCi/kDFtxsCYrFYa9eWnnEQJX1h5m9LEHtDAel0OjK3IF8Q6HggPC+kUKanM5/DAELVrWcgDNWGGfhBkAnHzn8KOwVSdOsxEU4G/nkBIM2xMx+Xx1etQNXMBxB0yl82fjHLvlIx/752vA6gGuYdgM76d+bfkuhweSpbDnrjAyiGdYOA84FFf4irR2cKE8XVpFsBKEbqKkFcDiyqMChVsjOv1zLWA6i6eRFEY75uMxaJ5aBTzE+E6U6qbp0B4a7/XvCSZB4qF/KvGt0VUg3rJ4DO2oWS5XC5kH/SKOx5oBrWPIDNAVkmF+a+WLOzs4uNIBTXrRMCeAjCRn8POBftEoOZTKYa2gN3Mt6X7CGOvCPQ9sD5v3TsnKuy93iEHmPcSO8Q4LcAtgYgTx075yrNoQCvEt3cKUBlELp9ujI/minkXLXrIHUq708c29USaXUARH09IdwrTWVHQlVenkwcMndXJc0QsMkXYNxyCtlzvurWao5qJPcALQUAXYGeXHfs3KXlsdAXSdFS+4jEVN0RS1wpFbPXPJEaiaJo6QMk5BuAOgKyXSjZ2ZsNAW7ooD6gMSKTILTXQJgIp5sCuCFFM/tJUB5AWw3ke9OAf5WYSQkaJ0KrB2F8XRfAzahaagBC3PfyVTn8F5mSzLPPdrcaAAAAAElFTkSuQmCC"
                  class="top_back"></div><span data-v-60016932="" class="head_text">设置</span><span data-v-60016932=""
              class="right_menu"></span>
      </div>
      <div data-v-60016932="" class="set-list">
          <div data-v-60016932="" class="set-list_item"><span data-v-60016932=""><i data-v-60016932=""
                      class="person-icon position-icon1"></i>消息时间显示</span>
     
            <van-switch v-model="checked" size="18px" active-color="#ff8439" inactive-color="#9ca3bf"/>
          </div>
          <div data-v-60016932="" class="set-list_item"><span data-v-60016932=""><i data-v-60016932=""
                      class="person-icon position-icon2"></i>中奖提示</span>
                      <van-switch v-model="checked2" size="18px" active-color="#ff8439" inactive-color="#9ca3bf"/>
          </div>
          <div data-v-60016932="" class="set-list_item"><span data-v-60016932=""><i data-v-60016932=""
                      class="person-icon position-icon2"></i>安静模式</span>
                      <van-switch v-model="checked3" size="18px" active-color="#ff8439" inactive-color="#9ca3bf"/>
          </div>
      </div>
      <div data-v-60016932="" class="set-list">
          <p data-v-60016932="" class="set-list_item" @click="goSetPayPwd">
            <span data-v-60016932=""><i data-v-60016932="" class="person-icon position-icon4"></i>设置提现密码</span>
            <img data-v-60016932=""
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAkCAYAAACJ8xqgAAADQUlEQVRIS52WTWgTURDH/5MNrdRaEWkRLB5EQfADQaGK1mSjRakoCBpQm4R81AhqQT140IOCXkQU9KA1aWOTViEigqIgrdnED1DwInoRehApKi0iVg22Zndk17bE9r121zm+mf+PmZ1585YAoKMnr7LBKRCYdASiIfWZef4/RolubR0xPQa4agzw3cXcFAn6Xv4XMJnR3gBYMUn8VSGXJ9ziMX2OjJIZbRBA7WQVgQYZvCEWUPudECmZzh8F8UWJaEA3ShvioaYPdqFkNSWtXWDCcYmoXymhMRxWP9uBWkBmps7uwjUGHxCJGHhTYehqKLTly0xQC2haNptVhn/VpUG8TyJ6qVeWtsb9Td+mg04AzaDTmuauH6A7AO+UiPJ68cf2eHxHUQb9BziWacXwSO1DAJvFInpYUzm4y+/3j4r8U4BmUHv7/SpldnUfGOuFUMLtmoqhvX6/X586bpLc27O9c5URdx7Aagn0RnS/N0JEXO4XZjge0Nn5pJbd+hMmLBN2n/lKa9DXZhtoBia6tXpiKgC8WJgp41wsqJ4a902b4XhQMqMtAaABqBdD+UQs6Dtv+mwBzcDrN3LLXQqZ0Cn33roboEOtAe9V20Cr/J7cGjLMVYe5gkwZjH2OgCako0vbyC56VLY/y9mfHAM707kGg6gXwBxBll8cAVPdhZU6GwUA84QlE8K2gamewlLD4GcMrhN3mo7Fgt5LtoDtXb2LFJf7uWxsCDgdDahnbI1NKqUt0N14CsCcRYHRxVjAO7Gcp82wq6tv/qhL0QhYKd4sdD3S4jlYfp+lwLHl8AhAg+Sb3ayZNRicvHHk66uq+gEAr6TMe3qxenc8vvb3jOsrm81WDI/U3QW4WVJm7ufXYnNbW/OI2F92ar0ro7W3wNgjWZMv9OKPzbaegL8vn9bBoLAE9lqvLHlsP1KJdO4yER2RwN65fiuNkcimIYl/4thqSjKtnQXhpHjM8J6BxtYWdWAmmDXYyYx2GMAVSTc/Auxx8n9DiYw2QMBCAXAIDF8sqL61k9l4DCUz+dcAr5ok+kaMLdGg+soJzCp56g8nFRnY1hrwmvfXsVlNSaQf+4iUDICSy+BoJKT2OSaNCf4AKrcwtfOX+9UAAAAASUVORK5CYII=">
          </p>
          <p data-v-60016932="" class="set-list_item"><span data-v-60016932=""><i data-v-60016932=""
                      class="person-icon position-icon4"></i>关于CG</span><img data-v-60016932=""
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAkCAYAAACJ8xqgAAADQUlEQVRIS52WTWgTURDH/5MNrdRaEWkRLB5EQfADQaGK1mSjRakoCBpQm4R81AhqQT140IOCXkQU9KA1aWOTViEigqIgrdnED1DwInoRehApKi0iVg22Zndk17bE9r121zm+mf+PmZ1585YAoKMnr7LBKRCYdASiIfWZef4/RolubR0xPQa4agzw3cXcFAn6Xv4XMJnR3gBYMUn8VSGXJ9ziMX2OjJIZbRBA7WQVgQYZvCEWUPudECmZzh8F8UWJaEA3ShvioaYPdqFkNSWtXWDCcYmoXymhMRxWP9uBWkBmps7uwjUGHxCJGHhTYehqKLTly0xQC2haNptVhn/VpUG8TyJ6qVeWtsb9Td+mg04AzaDTmuauH6A7AO+UiPJ68cf2eHxHUQb9BziWacXwSO1DAJvFInpYUzm4y+/3j4r8U4BmUHv7/SpldnUfGOuFUMLtmoqhvX6/X586bpLc27O9c5URdx7Aagn0RnS/N0JEXO4XZjge0Nn5pJbd+hMmLBN2n/lKa9DXZhtoBia6tXpiKgC8WJgp41wsqJ4a902b4XhQMqMtAaABqBdD+UQs6Dtv+mwBzcDrN3LLXQqZ0Cn33roboEOtAe9V20Cr/J7cGjLMVYe5gkwZjH2OgCako0vbyC56VLY/y9mfHAM707kGg6gXwBxBll8cAVPdhZU6GwUA84QlE8K2gamewlLD4GcMrhN3mo7Fgt5LtoDtXb2LFJf7uWxsCDgdDahnbI1NKqUt0N14CsCcRYHRxVjAO7Gcp82wq6tv/qhL0QhYKd4sdD3S4jlYfp+lwLHl8AhAg+Sb3ayZNRicvHHk66uq+gEAr6TMe3qxenc8vvb3jOsrm81WDI/U3QW4WVJm7ufXYnNbW/OI2F92ar0ro7W3wNgjWZMv9OKPzbaegL8vn9bBoLAE9lqvLHlsP1KJdO4yER2RwN65fiuNkcimIYl/4thqSjKtnQXhpHjM8J6BxtYWdWAmmDXYyYx2GMAVSTc/Auxx8n9DiYw2QMBCAXAIDF8sqL61k9l4DCUz+dcAr5ok+kaMLdGg+soJzCp56g8nFRnY1hrwmvfXsVlNSaQf+4iUDICSy+BoJKT2OSaNCf4AKrcwtfOX+9UAAAAASUVORK5CYII=">
          </p>
          <p data-v-60016932="" class="set-list_item"><span data-v-60016932=""><i data-v-60016932=""
                      class="person-icon position-icon6"></i>帮助与反馈</span><img data-v-60016932=""
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAkCAYAAACJ8xqgAAADQUlEQVRIS52WTWgTURDH/5MNrdRaEWkRLB5EQfADQaGK1mSjRakoCBpQm4R81AhqQT140IOCXkQU9KA1aWOTViEigqIgrdnED1DwInoRehApKi0iVg22Zndk17bE9r121zm+mf+PmZ1585YAoKMnr7LBKRCYdASiIfWZef4/RolubR0xPQa4agzw3cXcFAn6Xv4XMJnR3gBYMUn8VSGXJ9ziMX2OjJIZbRBA7WQVgQYZvCEWUPudECmZzh8F8UWJaEA3ShvioaYPdqFkNSWtXWDCcYmoXymhMRxWP9uBWkBmps7uwjUGHxCJGHhTYehqKLTly0xQC2haNptVhn/VpUG8TyJ6qVeWtsb9Td+mg04AzaDTmuauH6A7AO+UiPJ68cf2eHxHUQb9BziWacXwSO1DAJvFInpYUzm4y+/3j4r8U4BmUHv7/SpldnUfGOuFUMLtmoqhvX6/X586bpLc27O9c5URdx7Aagn0RnS/N0JEXO4XZjge0Nn5pJbd+hMmLBN2n/lKa9DXZhtoBia6tXpiKgC8WJgp41wsqJ4a902b4XhQMqMtAaABqBdD+UQs6Dtv+mwBzcDrN3LLXQqZ0Cn33roboEOtAe9V20Cr/J7cGjLMVYe5gkwZjH2OgCako0vbyC56VLY/y9mfHAM707kGg6gXwBxBll8cAVPdhZU6GwUA84QlE8K2gamewlLD4GcMrhN3mo7Fgt5LtoDtXb2LFJf7uWxsCDgdDahnbI1NKqUt0N14CsCcRYHRxVjAO7Gcp82wq6tv/qhL0QhYKd4sdD3S4jlYfp+lwLHl8AhAg+Sb3ayZNRicvHHk66uq+gEAr6TMe3qxenc8vvb3jOsrm81WDI/U3QW4WVJm7ufXYnNbW/OI2F92ar0ro7W3wNgjWZMv9OKPzbaegL8vn9bBoLAE9lqvLHlsP1KJdO4yER2RwN65fiuNkcimIYl/4thqSjKtnQXhpHjM8J6BxtYWdWAmmDXYyYx2GMAVSTc/Auxx8n9DiYw2QMBCAXAIDF8sqL61k9l4DCUz+dcAr5ok+kaMLdGg+soJzCp56g8nFRnY1hrwmvfXsVlNSaQf+4iUDICSy+BoJKT2OSaNCf4AKrcwtfOX+9UAAAAASUVORK5CYII=">
          </p>
      </div>
      <div data-v-60016932="" class="set-list">
          <p data-v-60016932="" class="set-list_item" @click="$parent.outLogin"><span data-v-60016932=""><i data-v-60016932=""
                      class="person-icon position-icon3"></i>退出</span><img data-v-60016932=""
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAkCAYAAACJ8xqgAAADQUlEQVRIS52WTWgTURDH/5MNrdRaEWkRLB5EQfADQaGK1mSjRakoCBpQm4R81AhqQT140IOCXkQU9KA1aWOTViEigqIgrdnED1DwInoRehApKi0iVg22Zndk17bE9r121zm+mf+PmZ1585YAoKMnr7LBKRCYdASiIfWZef4/RolubR0xPQa4agzw3cXcFAn6Xv4XMJnR3gBYMUn8VSGXJ9ziMX2OjJIZbRBA7WQVgQYZvCEWUPudECmZzh8F8UWJaEA3ShvioaYPdqFkNSWtXWDCcYmoXymhMRxWP9uBWkBmps7uwjUGHxCJGHhTYehqKLTly0xQC2haNptVhn/VpUG8TyJ6qVeWtsb9Td+mg04AzaDTmuauH6A7AO+UiPJ68cf2eHxHUQb9BziWacXwSO1DAJvFInpYUzm4y+/3j4r8U4BmUHv7/SpldnUfGOuFUMLtmoqhvX6/X586bpLc27O9c5URdx7Aagn0RnS/N0JEXO4XZjge0Nn5pJbd+hMmLBN2n/lKa9DXZhtoBia6tXpiKgC8WJgp41wsqJ4a902b4XhQMqMtAaABqBdD+UQs6Dtv+mwBzcDrN3LLXQqZ0Cn33roboEOtAe9V20Cr/J7cGjLMVYe5gkwZjH2OgCako0vbyC56VLY/y9mfHAM707kGg6gXwBxBll8cAVPdhZU6GwUA84QlE8K2gamewlLD4GcMrhN3mo7Fgt5LtoDtXb2LFJf7uWxsCDgdDahnbI1NKqUt0N14CsCcRYHRxVjAO7Gcp82wq6tv/qhL0QhYKd4sdD3S4jlYfp+lwLHl8AhAg+Sb3ayZNRicvHHk66uq+gEAr6TMe3qxenc8vvb3jOsrm81WDI/U3QW4WVJm7ufXYnNbW/OI2F92ar0ro7W3wNgjWZMv9OKPzbaegL8vn9bBoLAE9lqvLHlsP1KJdO4yER2RwN65fiuNkcimIYl/4thqSjKtnQXhpHjM8J6BxtYWdWAmmDXYyYx2GMAVSTc/Auxx8n9DiYw2QMBCAXAIDF8sqL61k9l4DCUz+dcAr5ok+kaMLdGg+soJzCp56g8nFRnY1hrwmvfXsVlNSaQf+4iUDICSy+BoJKT2OSaNCf4AKrcwtfOX+9UAAAAASUVORK5CYII=">
          </p>
      </div>
  </div>
  </div>
</template>
<script>
export default {
  name: 'userCent',
  data() {
    return {
      checked:true,
      checked2:true,
      checked3:false,
    };
  },
  created() {

  },
  methods: {
    back(){
      window.history.go(-1)
    },
    goSetPayPwd(){
      this.$router.push({
        path:'/password',
        query:{
          type:2
        }
      })
    }
  },
  mounted() {

  },
  updated() {

  },
};
</script>
<style lang="scss" scoped>
.Setting[data-v-60016932] {
  width: 100%;
  height: 100vh;
  background-color: #f3f3f6;
}
.Setting .head_area[data-v-60016932] {
  height: 1.33333rem;
  background: #fff;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding-left: 0.48rem;
  padding-right: 0.48rem;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  box-sizing: border-box;
}
.Setting .head_area .leftImg[data-v-60016932] {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  text-align: left;
}
.Setting .head_area .leftImg .top_back[data-v-60016932] {
  width: 0.21333rem;
  height: 0.37333rem;
}
.Setting .head_area .head_text[data-v-60016932] {
  font-size: 0.50667rem;
  font-family: PingFang SC;
  color: #424653;
  width: 45%;
  text-align: center;
}
.Setting .head_area .right_menu[data-v-60016932] {
  font-size: 0.37333rem;
  font-family: PingFang SC;
  color: #424653;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  text-align: right;
}
.Setting .set-list[data-v-60016932] {
  margin-top: 0.26667rem;
  background: #fff;
  box-sizing: border-box;
}
.Setting .set-list .set-list_item[data-v-60016932] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding-left: 0.4rem;
  padding-right: 0.4rem;
  font-size: 0.37333rem;
  font-family: PingFang SC;
  font-weight: 700;
  color: #424653;
  height: 1.33333rem;
  line-height: 1.33333rem;
  text-align: left;
  border-bottom: 0.02667rem solid #e1e1e1;
}
.Setting .set-list .set-list_item img[data-v-60016932] {
  width: 0.13333rem;
  height: 0.24rem;
}
.Setting .set-list .set-list_item .van-switch[data-v-60016932] {
  background-color: #9ca3bf;
}
.Setting .set-list .set-list_item .van-switch--on[data-v-60016932] {
  background-color: #ff8439 !important;
}
.Setting .set-list .set-list_item[data-v-60016932]:last-child {
  border-bottom: none;
}
</style>
